import { LeadList } from "./LeadList";
import { LeadShow } from "./LeadShow";

export default {
  list: LeadList,
  show: LeadShow,
  recordRepresentation: (record: { initial_message?: string; id: string | number }) =>
    record?.initial_message
      ? record.initial_message.slice(0, 60)
      : `Lead #${record?.id}`,
};
